import { toggleActive } from '../helpers/ActionHelper';

export class ResourceSingleComponent {
	container;

	constructor() {
		this.container = document.querySelector('body.single-resource');
	}

	initialize() {
		if (!this.container) {
			return;
		}

		this.addEventListeners();
	}

	addEventListeners() {
		const accordionToggleBtns = this.container.querySelectorAll(
			'.counter-hierarchy .ez-toc-toggle'
		);
		if (accordionToggleBtns.length) {
			accordionToggleBtns.forEach((accordionToggleBtn) => {
				accordionToggleBtn.addEventListener('click', (e) =>
					this.accordionToggleBtnClickHandler(e)
				);
			});
		}
	}

	accordionToggleBtnClickHandler(e) {
		e.stopPropagation();

		const container = e.target.closest('.counter-hierarchy');
		if (container) {
			toggleActive(container);
		}
	}
}
